// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { ATTACH_FILE, DOWNLOAD_FILE } from '~/utils/constants/actionType';
import fileApi from '~/apis/file';

export const downloadFile = createAsyncThunk(DOWNLOAD_FILE, async (fileId: string, { rejectWithValue }) => {
  try {
    const res = await fileApi.downloadFile(fileId);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const attachFile = createAsyncThunk(ATTACH_FILE, async (formData: FormData, { rejectWithValue }) => {
  try {
    const res = await fileApi.attachFile(formData);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
